import LoginPage from "../views/Pages/LoginPage";
import Fingerprint from "@material-ui/icons/Fingerprint";
import LoadingPage from "../views/Pages/LoadingPage";
import RemindPasswordPage from "../views/Pages/RemindPasswordPage";
import ChangePasswordPage from "../views/Pages/ChangePasswordPageTS";
import PrivacyPolicyPage from "../views/Pages/PrivacyPolicyPage";

const pagesRoutes = [
  {
    path: "/pages/login-page",
    name: "Login Page",
    short: "Login",
    mini: "LP",
    icon: Fingerprint,
    component: LoginPage,
  },
  {
    path: "/pages/loading",
    name: "Loading",
    short: "Loading",
    mini: "Loading",
    icon: Fingerprint,
    component: LoadingPage,
  },
  {
    path: "/pages/remind-password",
    name: "Remind Password",
    short: "Remind Password",
    mini: "Remind Password",
    icon: Fingerprint,
    component: RemindPasswordPage,
  },
  {
    path: "/pages/change-password",
    name: "Change Password",
    short: "Change Password",
    mini: "Change Password",
    icon: Fingerprint,
    component: ChangePasswordPage,
  },
  {
    path: "/pages/wisene-watch-privacy",
    name: "Privacy Policy",
    short: "Privacy Policy",
    mini: "Privacy Policy",
    icon: Fingerprint,
    component: PrivacyPolicyPage,
  },
  {
    redirect: true,
    path: "/",
    pathTo: "/pages/login-page",
    name: "Login Page",
  },
];

export default pagesRoutes;
